module.exports = __webpack_public_path__ + "static/media/ai-translations-soyun-3.02f3fc26.md";